import { createStore } from 'vuex'
import user from './modules/user'
import common from './modules/common'
import earthworm from './modules/earthworm'

export default createStore({
  modules: {
    user,
    common,
    earthworm
  }
})
